import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAppStore } from '@/hooks/useAppStore';

export const LogoutPage: React.FC = () => {
  const user = useAppStore((state) => state.user);
  const logout = useAppStore((state) => state.logout);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      console.log("Logging out user", user);
      logout();
      navigate("/login");
    }
  }, [user, logout]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
      <h1 className="text-2xl font-thin text-chotto-gold mb-4">Thank You!</h1>
      <p className="text-xl text-neutral-300 mb-8">Logging Out...</p>
      <Button asChild variant="link" className="text-lg text-chotto-gold">
        <Link to="/login">Go back home</Link>
      </Button>
    </div>
  );
};

export default LogoutPage;
